import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content-box px-0 pb-0 user-table-wrapper" }
const _hoisted_2 = { class: "padding-inner py-0 d-flex align-items-center justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "eSIM Profiles", -1)
const _hoisted_4 = { class: "mt-5" }
const _hoisted_5 = { class: "user-table" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center pe-3 w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectDropdown = _resolveComponent("SelectDropdown")!
  const _component_TableHeadCell = _resolveComponent("TableHeadCell")!
  const _component_EsimProfilesTableRow = _resolveComponent("EsimProfilesTableRow")!
  const _component_TableView = _resolveComponent("TableView")!
  const _component_AppTableController = _resolveComponent("AppTableController")!
  const _component_AppCollapsable = _resolveComponent("AppCollapsable")!

  return (_openBlock(), _createBlock(_component_AppCollapsable, {
    "collapsed-height": 600,
    "initial-opened": true,
    class: "esim-profiles-table",
    onOpen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapseToggle(false))),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.collapseToggle(true)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_SelectDropdown, {
            list: _ctx.esimStatuses,
            "on-select": _ctx.onEsimStatusFiler,
            placeholder: "Choose status",
            "check-type": "radio"
          }, null, 8, ["list", "on-select"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_AppTableController, {
              "show-table": !!_ctx.esimProfilesList.length,
              "empty-key": "profiles",
              "empty-icon": "esim",
              "table-loading": _ctx.isLoading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TableView, { class: "accordion-table no-shadow" }, {
                  "table-head": _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHead, ({ size, id, label }, idx) => {
                        return (_openBlock(), _createBlock(_component_TableHeadCell, {
                          id: id,
                          key: idx,
                          name: label,
                          size: size
                        }, null, 8, ["id", "name", "size"]))
                      }), 128))
                    ])
                  ]),
                  "table-body": _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.esimProfilesList, ({
                    activeFrom,
                    activeTo,
                    balance,
                    device,
                    esim,
                    id,
                    installed,
                    package: esimPackage,
                    profileName
                  }) => {
                      return (_openBlock(), _createBlock(_component_EsimProfilesTableRow, {
                        key: id,
                        "active-to": activeTo,
                        "active-from": activeFrom,
                        balance: balance,
                        device: device,
                        "profile-id": id,
                        esim: esim,
                        installed: installed,
                        "esim-package": esimPackage,
                        "profile-name": profileName
                      }, null, 8, ["active-to", "active-from", "balance", "device", "profile-id", "esim", "installed", "esim-package", "profile-name"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["show-table", "table-loading"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}